<script setup lang="ts">
import { mapAuthActions } from "@frontegg/vue";
import router from "../../router/router";
import { organizationsStore } from "../..//stores/Utils/auth/Organizations";
import Button from "../Reusables/Buttons/Button.vue";
import { computed, ref } from "vue";
import TextInput from "../Reusables/Inputs/TextInput.vue";
import Tenant from "../../types/auth/Tenant";

const organizations = ref<Tenant[]>(organizationsStore().getTenants() ?? []);
const searchQuery = ref<string>("");

const filteredOrganizations = computed(() => {
  if (searchQuery.value) {
    return searchOrganizationByName(searchQuery.value);
  }
  return organizations.value;
});

const searchOrganizationByName = (query: string): { tenantId: string; name: string }[] =>
  organizations.value.filter((org) => org.name.toLowerCase().includes(query.toLowerCase()));

const switchTenant = (tenantId: string) => {
  if (tenantId) {
    mapAuthActions("switchTenant")({ tenantId });
    setTimeout(() => {
      const currentTenantId = tenantId;
      const currentOrg = organizationsStore()
        .getTenants()
        ?.find((t) => t.tenantId === currentTenantId);
      if (currentOrg === undefined) return;
      organizationsStore().setCurrentTenant(currentOrg);
      Object.keys(localStorage)
        .filter((key) => key.includes("-material-filters-"))
        .forEach((key) => localStorage.removeItem(key));
      router.push({ path: "/" }).then(() => {
        location.reload();
      });
    }, 1500);
  }
};
</script>

<template>
  <div class="h-[600px] w-full">
    <div class="flex w-full flex-col gap-4">
      <h1 v-if="organizationsStore().getCurrentTenant()">
        You are currently connected to
        {{ organizationsStore().getCurrentTenant()?.name }}
      </h1>
      <TextInput
        v-model:value="searchQuery"
        :is-search="true"
        color="default"
        placeholder="Search for an organization" />
      <div class="flex max-h-[500px] w-full flex-wrap gap-4 overflow-auto">
        <Button
          v-for="org in filteredOrganizations"
          :key="org.tenantId"
          :label="org.name"
          :color="organizationsStore().getCurrentTenant()?.tenantId === org.tenantId ? 'primary' : 'button'"
          class="h-10"
          @click="switchTenant(org.tenantId)" />
      </div>
      <span
        v-if="filteredOrganizations.length === 0"
        class="text-input-stroke text-center"
        >No Organizations found</span
      >
    </div>
  </div>
</template>
